import { render } from "./SystemSelfCheck.vue?vue&type=template&id=a027cd92&scoped=true"
import script from "./SystemSelfCheck.vue?vue&type=script&lang=js"
export * from "./SystemSelfCheck.vue?vue&type=script&lang=js"

import "./SystemSelfCheck.vue?vue&type=style&index=0&id=a027cd92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a027cd92"],['__file',"src/views/ProductDiagnosis/components/SystemSelfCheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a027cd92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a027cd92', __exports__)) {
    api.reload('a027cd92', __exports__)
  }
  
  module.hot.accept("./SystemSelfCheck.vue?vue&type=template&id=a027cd92&scoped=true", () => {
    api.rerender('a027cd92', render)
  })

}


export default __exports__